module.exports = __webpack_public_path__ + "static/media/rightchev.07346259.svg";